// JsFromRoutes CacheKey faf74b70c09912eef558edbac95e5814
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/storage/representations/proxy/:signed_blob_id/:variation_key/*filename'),
}
